import { Form, Tabs } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CUSTOMER_TYPE } from "../../../../components/FormInputs/constants";
import { useSupplierConfig } from "../../../../hooks/useSupplierConfig";
import { getSupplierData } from "../../../../Redux/Selectors/appConfigSelector";
import BusinessForm from "./BusinessForm";
import PersonalForm from "./PersonalForm";

const MainMemberForm = ({ onFormIsValid, handleOnContinue }) => {
  const { t } = useTranslation("shop");
  const supplierData = useSelector(getSupplierData);
  const [businessForm] = Form.useForm();
  const [personalForm] = Form.useForm();

  const { createCustomer, createCompany } = useSupplierConfig();
  const [customerType, setCustomerType] = useState(CUSTOMER_TYPE.PERSONAL);

  const onChange = () => {
    const form =
      customerType === CUSTOMER_TYPE.PERSONAL ? personalForm : businessForm;
    // rc-field-form validates the changed field right after `onValuesChange`,
    // which discards the validation started here (`outOfDate`) even when the
    // form is valid. Defer so ours is the last validation to be registered.
    setTimeout(() => {
      form
        .validateFields()
        .then(() => {
          onFormIsValid(true);
          form.submit();
        })
        .catch((err) => {
          // `outOfDate` means another change came in, not that the form is
          // invalid: that change's own validation settles the final state.
          if (!err?.outOfDate) {
            onFormIsValid(false);
          }
        });
    }, 0);
  };

  const items = [
    {
      key: CUSTOMER_TYPE.PERSONAL,
      label: t("personal"),
      children: (
        <PersonalForm
          onSubmit={handleOnContinue}
          form={personalForm}
          onChange={onChange}
          initialValues={{
            phonePrefix: createCustomer.phonePrefixByRegion,
            type: createCustomer.personalIdType,
            nationality: createCustomer.nationality,
            createdBy: supplierData._id,
            customerType: CUSTOMER_TYPE.PERSONAL,
          }}
        />
      ),
    },
    {
      key: CUSTOMER_TYPE.BUSINESS,
      label: t("business"),
      children: (
        <BusinessForm
          formEnabled={false}
          onSubmit={handleOnContinue}
          onChange={onChange}
          form={businessForm}
          initialValues={{
            phonePrefix: createCompany.phonePrefixByRegion,
            type: createCompany.companyIdType,
            nationality: createCompany.nationality,
            createdBy: supplierData._id,
            customerType: CUSTOMER_TYPE.BUSINESS,
          }}
        />
      ),
    },
  ];

  const onChangeTab = (key) => {
    personalForm.resetFields();
    businessForm.resetFields();
    onFormIsValid(false);
    setCustomerType(key);
  };

  return (
    <>
      <Tabs
        defaultActiveKey={CUSTOMER_TYPE.PERSONAL}
        items={items}
        onChange={onChangeTab}
      />
    </>
  );
};

export default MainMemberForm;
